app.TaxProfileList = app.AbstractCollection.extend({
  model: app.TaxProfile,

  url() {
    return app.apiPathForLocation('/taxProfiles');
  },
});
